import axios from "axios";

import type { Coupon } from "../components/CouponPage/types";
import fetchCrmToken from "./fetchCrmToken";

export default async (coupon: string): Promise<Coupon | null> => {
  

  console.log("fetchCoupon", coupon);
  const serviceToken = await fetchCrmToken();

  console.log("serviceToken", serviceToken);
  if (!serviceToken) return null;

  const url = `https://apis.anahealth.app/crm/coupons/validate/${encodeURIComponent(coupon)}`;
  const { data } = await axios.get<any>(url, {
    headers: { Authorization: `service ${serviceToken}` },
  });

  // A rota /coupons/validate retorna { valid, exists, coupon, message }
  if (!data || !data.valid || !data.coupon) return null;

  const apiCoupon = data.coupon;

  // Se houver um item, retornamos o mapeado para o shape já utilizado no app
  const discounted = Number(apiCoupon?.discounted_value ?? 0);
  const baseValue = Number(apiCoupon?.value ?? 0);
  const resolvedPrice = Number.isFinite(discounted) && discounted > 0 ? discounted : baseValue;

  const mappedCoupon: Coupon = {
    id: String(apiCoupon?.id ?? "NULL"),
    createdTime: String(apiCoupon?.created_at ?? ""),
    fields: {
      remainingQuantity: Number(apiCoupon?.remaining ?? 0),
      price: Number.isFinite(resolvedPrice) ? resolvedPrice : 0,
      category: String(apiCoupon?.category ?? ""),
      pricePerPerson: Number.isFinite(resolvedPrice) ? resolvedPrice : 0,
      discountedPrice: discounted,
      companyName: "",
      totalQuantity: Number(apiCoupon?.quantity ?? 0),
      cupom: String(apiCoupon?.name ?? coupon),
      discount: Number(apiCoupon?.discount ?? 0),
      companyId: apiCoupon?.organization_id ?? null,
    },
  };

  return mappedCoupon;
};
